'use strict';

DoohApps
    .factory('CompanyActionsData', ['restApi', function (restApi) {
        var controllerName = 'Company/';

        return {
            getCompanyActionList: function (successCallback, objectFilterOptions) {
                restApi.GetApiMethod(successCallback, controllerName + 'GetCompanyActionsList', objectFilterOptions);
            }
        }
    }]);
